import axios from "axios";
import API_BASE_URL from "./apiConfig";

const API_URL = `${API_BASE_URL}/api`;

const fileService = {
  async uploadFile(patientId, appointmentId, file, doctorId) {
    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("patientId", patientId);
      formData.append("appointmentId", appointmentId);
      formData.append("doctorId", doctorId);

      const response = await axios.post(
        `${API_URL}/files/upload`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  async getFilesByAppointment(appointmentId) {
    try {
      const response = await axios.get(
        `${API_URL}/files/appointment/${appointmentId}`
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  async getFilesByPatient(patientId) {
    try {
      const response = await axios.get(
        `${API_URL}/files/patient/${patientId}`
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  async getFileById(fileId) {
    try {
      const response = await axios.get(`${API_URL}/files/${fileId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  async deleteFile(fileId) {
    try {
      const response = await axios.delete(`${API_URL}/files/${fileId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  async getDownloadUrl(fileId) {
    try {
      const response = await axios.get(`${API_URL}/files/${fileId}/download-url`);
      return response.data.url;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
};

export default fileService;
